import 'whatwg-fetch';
import 'font-awesome/scss/font-awesome.scss';
import 'jbc-front/styles/default.scss';
import 'normalize.css';
import { ApolloProvider } from '@apollo/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import configureApollo from './configureApollo';
import ErrorBoundary from './components/ErrorBoundary';
import { NotificationsProvider } from './components/Notifications';
import Layout from './Layout';
import * as pages from './pages';
import './datadog';

const client = configureApollo('/graphql');

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      errorElement: <ErrorBoundary />,
      children: [
        { path: '/', element: <pages.Input /> },
        { path: '/finished', element: <pages.Finished /> },
        { path: '/start', element: <pages.Start /> },
      ],
    },
  ],
  { future: { v7_relativeSplatPath: true } },
);

const App = () => (
  <ApolloProvider client={client}>
    <NotificationsProvider>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </NotificationsProvider>
  </ApolloProvider>
);

export default App;
